import { commonComponents as cc } from "@/components/common";
import { Route as EntryValueRoute } from "@/routes/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/entry-value/$entryValueId";
import { services as s } from "@/services";
import type { EntryViewT } from "@/types/database/entries";
import { useParams } from "@tanstack/react-router";
import { Fragment } from "react";
import { EntryValueSwitch } from "../../entry-values/components/EntryValueSwitch";
import { useProfileQuery } from "../../profile/api/selectProfile";
import { sortEntryValuesView } from "../services/sortEntryValuesView";
interface Props {
	entry: EntryViewT;
}
const EditEntry = ({ entry }: Props) => {
	const { diaryId } = useParams({ strict: false });
	const { data: profile } = useProfileQuery();

	if (!entry) return null;

	return (
		<>
			{profile?.is_super_user && (
				<cc.Group title="Entry Details">
					<cc.EditDialog
						locked={true}
						label="Entry Label"
						info={entry.timing_label}
					/>
					<cc.EditDialog
						locked={true}
						label="Entry Time"
						info={s.time.formatDateTime(
							entry.calculated_entry_time ?? entry.entry_time,
						)}
					/>
				</cc.Group>
			)}
			<cc.Group title="Entry Values">
				{sortEntryValuesView(entry.entry_values)?.map((ev) => (
					<cc.EditRow
						key={ev.entry_value_id}
						route={{
							to: EntryValueRoute.to,
							params: {
								entryId: entry.entry_id,
								trackerId: entry.tracker_id,
								diaryId: diaryId,
								entryValueId: ev.entry_value_id,
							},
						}}
						show={true}
						info={<EntryValueSwitch entryValue={ev} size="lg" />}
					/>
				))}
			</cc.Group>
		</>
	);
};

export default EditEntry;
